import { IEmailDomain } from "store/entities/email-domains";

import { IKeyAny } from "../api-client";
import { BaseApi } from "../base";

type ICreateEmailDomainPayload = Partial<IEmailDomain>;

function parseCreateEmailDomainPayload(payload: ICreateEmailDomainPayload): IKeyAny {
  return {
    name: payload.name,
  };
}

export default class EmailDomainApi extends BaseApi {
  protected readonly prefix = "emailDomains";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (data: Partial<IEmailDomain>) => this.post("", parseCreateEmailDomainPayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verify = (id: string) => this.post(`${id}/verify`);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteEmailDomain = (id: string) => this.delete(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isAvailable = (name: string) => this.get("available", { name });
}
